var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4 28.5336C8.4 28.2389 8.72832 28 9.13333 28H16.4667C16.8717 28 17.2 28.2389 17.2 28.5336C17.2 28.8283 16.8717 29.0672 16.4667 29.0672H9.13333C8.72832 29.0672 8.4 28.8283 8.4 28.5336ZM9.86667 30.6667C9.86667 30.372 10.195 30.1331 10.6 30.1331H17.9333C18.3383 30.1331 18.6667 30.372 18.6667 30.6667C18.6667 30.9614 18.3383 31.2002 17.9333 31.2002H10.6C10.195 31.2002 9.86667 30.9614 9.86667 30.6667ZM4.73333 32.2662C4.32832 32.2662 4 32.5051 4 32.7998C4 33.0944 4.32833 33.3333 4.73333 33.3333H17.2C17.605 33.3333 17.9333 33.0944 17.9333 32.7998C17.9333 32.5051 17.605 32.2662 17.2 32.2662H4.73333Z",
    fill: "url(#paint0_linear_3413_10038)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3906 15.1326C26.9277 15.0212 28.9085 14.7024 29.456 14.6682C29.8331 14.6446 30.683 14.9215 31.3642 15.1435C31.6938 15.2509 31.9839 15.3454 32.1619 15.3869C32.4575 15.4557 32.6704 15.6482 32.749 15.9259C32.7938 16.0842 32.729 16.2476 32.6303 16.3793L31.8133 17.4685C31.3575 18.0762 30.6013 18.3531 29.8428 18.3133C29.7892 18.3107 29.7339 18.308 29.6773 18.3055C28.4538 18.2514 27.1277 17.948 26.2617 17.082L25.594 16.4145C25.4416 16.2621 25.3411 16.0471 25.4296 15.8506C25.5815 15.5134 25.9522 15.2236 26.3906 15.1326ZM32.931 18.4007C33.4421 18.2116 33.9505 17.9665 34.5132 17.6267C34.938 17.3643 35.3391 17.382 35.5371 17.8196C35.6309 18.0509 35.5669 18.3372 35.3835 18.5066C35.0937 18.7964 34.7141 19.0389 34.2662 19.2476C33.954 19.3932 33.9022 19.8585 34.1458 20.102C34.3837 20.3281 34.3903 20.7525 34.1595 20.9858C33.9287 21.2191 33.5042 21.2172 33.2755 20.9818C33.175 20.8812 33.0291 20.7738 32.8472 20.6671C31.9754 20.1559 30.9173 20.215 29.9051 20.2716C29.8739 20.2734 29.8428 20.2751 29.8117 20.2768C29.2165 20.31 28.6256 20.2979 28.0635 20.2276C28.0493 20.2259 28.0352 20.2237 28.0213 20.2208C27.3689 20.0887 27.3956 18.7885 28.0539 18.6903C28.6403 18.6065 29.2359 18.5916 29.8234 18.6226C29.89 18.6261 29.9566 18.6297 30.0233 18.6334C31.0073 18.687 32.0096 18.7417 32.931 18.4007ZM26.7981 22.1875C27.4849 21.2257 28.6143 20.5918 29.7958 20.5606C30.4922 20.5421 31.1427 20.8947 31.5559 21.4556C32.0964 22.1893 32.7368 22.9263 33.3873 23.6748C35.2113 25.7737 37.1144 27.9636 37.1144 30.4283C37.1144 34.1469 33.7107 38.1827 29.6881 38.1827C25.6655 38.1827 22.2617 34.4568 22.2617 30.4283C22.2617 28.0286 23.937 25.8893 25.5411 23.8409C25.977 23.2842 26.4077 22.7342 26.7981 22.1875ZM25.2323 30.1374C25.2323 27.7479 27.1748 25.8054 29.5643 25.8054C31.9538 25.8054 33.8963 27.7479 33.8963 30.1374C33.8963 32.5269 31.9538 34.4694 29.5643 34.4694C27.1748 34.4694 25.2323 32.5269 25.2323 30.1374ZM30.23 28.6326L31.133 28.6326V27.9759H27.9866V28.669L28.9716 28.669C29.3272 28.669 29.6282 28.8788 29.7559 29.1889H27.9866V29.8455H29.7559C29.6282 30.1465 29.3272 30.3654 28.9716 30.3654H27.9866V31.2044L29.5826 32.8187L30.5493 32.8186L28.8165 31.0585H28.9715C29.7102 31.0585 30.3304 30.5386 30.4763 29.8455L31.1421 29.8456V29.1889H30.4763C30.4307 28.9883 30.3486 28.7967 30.23 28.6326Z",
    fill: "url(#paint1_linear_3413_10038)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8713 2.90351C30.0039 2.57229 30.0862 2.59088 30.0555 2.94489L29.7372 6.60646C29.7063 6.96062 29.957 7.16155 30.2963 7.05553L32.5058 6.36506C32.8452 6.2589 33.0135 6.44063 32.8806 6.77275L30.3511 13.0967C30.2186 13.4279 30.1363 13.4093 30.167 13.0553L30.4853 9.3937C30.5162 9.03954 30.2655 8.83862 29.9262 8.94463L27.7167 9.6351C27.3772 9.74126 27.209 9.55953 27.3419 9.22742L29.8713 2.90351Z",
    fill: "url(#paint2_linear_3413_10038)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3413_10038",
    x1: 4,
    y1: 30.6667,
    x2: 18.6667,
    y2: 30.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3413_10038",
    x1: 22.2617,
    y1: 26.4247,
    x2: 37.1144,
    y2: 26.4247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3413_10038",
    x1: 27.2964,
    y1: 8.00008,
    x2: 32.9261,
    y2: 8.00008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImps);
export default __webpack_public_path__ + "static/media/IMPS.643cc5415f45e4426f7b3cc597e3bf3c.svg";
export { ForwardRef as ReactComponent };